import { ChangeDetectionStrategy, Component, HostListener, Output, EventEmitter } from '@angular/core';
import { UrlBuilder } from '../core/url-builder/url-builder';

@Component({
    selector: 'global-popup',
    template: require('./global-popup.component.html'),
    styles: [require('./global-popup.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GlobalPopupComponent {
    @Output()
    public closing = new EventEmitter<void>();

    constructor(private urlBuilder: UrlBuilder) { }

    @HostListener('document:keydown.esc')
    public onBackToPortal() {
        this.urlBuilder
            .esa()
            .globalPopup()
            .empty()
            .navigate({ preserveQueryParams: true });
        this.closing.emit();
    }
}